import environment, { Environment } from "./env.base";

const baseApi = "https://ykl239vt18.execute-api.ap-south-1.amazonaws.com/prod/v1";
const env = environment(baseApi);

const devEnv: Environment = {
  ...env,
  api: {
    ...env.api,
  },
  isDevelopment: true,
};

export default devEnv;
